export const DETAIL_GET_CONTARCT_SUCCESS = "DETAIL_GET_CONTARCT_SUCCESS";
export const DETAIL_GET_CONTRACT_ERROR = "DETAIL_GET_CONTRACT_ERROR";
export const DETAIL_GET_CONTRACT_START = "DETAIL_GET_CONTRACT_START";

export const ADMIN_HISTORY_GET_CONTARCT_SUCCESS = "ADMIN_HISTORY_GET_CONTARCT_SUCCESS";
export const ADMIN_HISTORY_GET_CONTARCT_ERROR = "ADMIN_HISTORY_GET_CONTARCT_ERROR";
export const ADMIN_HISTORY_GET_CONTARCT_START = "ADMIN_HISTORY_GET_CONTARCT_START";